import axios, { AxiosRequestConfig } from 'axios';

/**
 * blobからファイルをダウンロードする(axios)
 */
export const downloadFileFromBlobByAxios = async (downloadUrl: string, fileName: string, onProgress: any): Promise<void> => {
  const options: AxiosRequestConfig = {
    responseType: 'blob',
    onDownloadProgress: (progressEvent: any) => {
      onProgress({ loadedBytes: progressEvent.loaded, total: progressEvent.total });
    },
  };

  await axios.get(downloadUrl, options)
    .then((response) => {
      saveBlobWithDynamicLink(fileName, new Blob([response.data], { type: 'application/octet-stream' }));
    })
    .catch((error) => {
      const errorMessage = {
        status: error.response.status,
        message: error.response.statusText,
      };
      throw errorMessage;
    });
};

function saveBlobWithDynamicLink(fileName: string, blob: Blob) {
  try {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
    link.remove();
  } catch (err) {
    console.log(`SAVE ERROR | ${err}`);
  }
}
